'use client';

import classNames from 'classnames';
import { IImage } from '@sapientpro/sapientpro-data-models';
import styles from './Card.module.scss';
import Button, { ButtonVariants } from '../../../components/Button';

const extractBoldText = (text: string) => text.split(/(\*\*.*?\*\*)/g).map(part => {
  const isBold = part.startsWith('**') && part.endsWith('**');
  return {
    text: isBold ? part.slice(2, -2) : part,
    isBold,
  };
}).filter(part => part.text);

type CardProps = {
  icon: IImage;
  title: string;
  subtitle: string;
  points: string[];
  calendly?: string;
  buttonText: string;
  isPrimary: boolean;
};

const Card = ({
  icon,
  title,
  subtitle,
  points,
  calendly,
  buttonText,
  isPrimary,
}: CardProps) => (
  <div className={classNames(styles.card, { [styles.card_primary]: isPrimary })}>
    <div className={styles.card__header}>
      <img
        className={styles.card__icon}
        src={icon.url}
        alt={icon.alternativeText ?? 'Card icon'}
      />
      <p className={classNames(styles.card__title, 'header4')}>{title}</p>
    </div>
    <div className={styles.divider} />
    <div className={styles.card__content}>
      <p className={styles.card__contentSubtitle}>{subtitle}</p>
      <ul className={styles.card__contentList}>
        {points.map((point) => {
          const textParts = extractBoldText(point);
          return (
            <li
              key={point}
              className={styles.card__contentListItem}
            >
              <span className={styles.card__contentListItemIcon}>
                <svg>
                  <use
                    xlinkHref='/media/check.svg#checkSVG'
                    href='/media/check.svg#checkSVG'
                  />
                </svg>
              </span>
              <span className={styles.card__contentListItemText}>
                {textParts.map(({ text, isBold }) => (
                  isBold
                    ? (<span className={styles.card__contentListItemText_bold}>{text}</span>)
                    : text
                ))}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
    <Button
      variant={isPrimary ? ButtonVariants.PRIMARY : ButtonVariants.OUTLINED}
      className={styles.card__button}
      onClick={() => calendly && window.open(calendly, '_blank')}
    >
      {buttonText}
    </Button>
    {isPrimary && <div className={styles.ellipse} />}
  </div>
);

export default Card;
